import { usePrivateMutation as useMutation } from "@/lib/query/core/use-private-mutation";
import { useQueryClient } from "@tanstack/react-query";
import type { ThemeVersion } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminThemes } from "@/lib/query/core/invalidation";
import { queryKeys } from "@/lib/query/core/query-keys";

type PublishThemeVersionInput = {
  themeId: string;
  versionId: string;
};

export function usePublishThemeVersionMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ themeId, versionId }: PublishThemeVersionInput) =>
      apiJsonClient<ThemeVersion>(
        endpoints.admin.themeVersionPublish(themeId, versionId),
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        },
      ),
    onSuccess: async (_data, variables) => {
      await invalidateAdminThemes(queryClient);
      await queryClient.invalidateQueries({
        queryKey: queryKeys.admin.themeById(variables.themeId),
        exact: true,
      });
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
